/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6c1a8563848c94aac7c751487b993bbc460e37fb";
